import React from 'react';

export default function LibraryStickyNavigation({ children }) {
	return <div className="sticky top-20 z-20 bg-white pb-4 border-b border-solitude">{children}</div>;
}
